import * as Actions from "../Actions/CustomCrmFormActions";

const initialState = {
    tags: null,
    info: null,
    error: null,
    warning: null
};

const CustomCrmForm = function (state = initialState, action) {
    switch (action.type) {
        case Actions.CUSTOMCRMFORM_TAGS:
            {
                return {
                    ...state,
                    tags: action.payload
                };
            }
        case Actions.CUSTOMCRMFORM_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.CUSTOMCRMFORM_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.CUSTOMCRMFORM_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default CustomCrmForm;
